import {
  IPCOSummaryTable,
  IPCOSummaryTableArray,
} from "@ispm/dynamic-form/interfaces/ISummaryTableInterface";
import { IgenomicsAction } from '@ispm/core/interfaces/genomics-action.interface';
import {SUMMARYTABLE_ACTIONS} from "@ispm/dynamic-form/components/summary-table/store/actions";


const initialSummaryState: IPCOSummaryTableArray = {
  summary: null,
  summaryTableModel: null
};

/**
 * @method summaryReducer
 * @param state
 * @param action
 */
export function summaryReducer(state: any = initialSummaryState,
  action: IgenomicsAction<any>): Array<any> {
  const newState = {...state};
  switch (action.type) {
    case SUMMARYTABLE_ACTIONS.ADD_SUMMARY:
      let summaryTableArray: Array<IPCOSummaryTable> = new Array<IPCOSummaryTable>();
      action.payload.forEach(item => {
        if (item instanceof Array && item.length > 0) {
          item.forEach(summaryItem => {
          const summaryRow: IPCOSummaryTable = {
            target: null,
            pirads: null,
            biopsies: null,
            sampleLabel: null,
            overallGleason: null,
            biopsyType: null,
            isSystemicBiopsies: null
          };
        // if (item instanceof Array && item.length > 0) {
        //   item.forEach(summaryItem => {
            summaryRow.target = summaryItem.ROI;
            summaryRow.biopsies = summaryItem.biopsies;
            summaryRow.overallGleason = summaryItem.overallGleason;
            summaryRow.pirads = summaryItem.pirads;
            summaryRow.sampleLabel = summaryItem.sampleLabel;
            summaryRow.biopsyType = summaryItem.biopsyType;
            summaryRow.isSystemicBiopsies = summaryItem.isSystemicBiopsies? summaryItem.isSystemicBiopsies : false;

            summaryTableArray = [...summaryTableArray, summaryRow];
          })
        }
        //summaryTableArray = [...summaryTableArray, summaryRow];
      });
     // newState.summary = action.payload;
     newState.summary = summaryTableArray;
     newState.summaryTableModel = action.payload;
    return newState;
    case SUMMARYTABLE_ACTIONS.RESET_SUMMARY:
      newState.summary = null;
      newState.summaryTableModel = null;
      return newState;
    default:
      return state;
  }
}

